import { render, staticRenderFns } from "./AddOrEditPermission.vue?vue&type=template&id=1c267b9c"
import script from "./AddOrEditPermission.vue?vue&type=script&lang=js"
export * from "./AddOrEditPermission.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditPermission.vue?vue&type=style&index=0&id=1c267b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports